import Profile from './Profile'
import Dashboard from './Dashboard'
import RegisterTracking from './RegisterTracking'
import UpdateTracking from './UpdateTracking'
import Tracking from './Tracking'
import Export from './Export'
import Delivery from './Delivery'
import Revenue from './Revenue'
import TopUp from './TopUp'
import HistoryTopUp from './HistoryTopUp'
import Payment from './Payment'
import History from './History'
import UpdateHistory from './UpdateHistory'

export default {
  Dashboard,
  Profile,
  RegisterTracking,
  UpdateTracking,
  UpdateHistory,
  Tracking,
  Delivery,
  Revenue,
  TopUp,
  HistoryTopUp,
  Payment,
  Export,
  History
}



// WEBPACK FOOTER //
// ./src/components/User/index.js